<div [@routerTransition]>
    <sub-header [title]="'JournalVouchers' | localize" [description]="'JournalVouchersHeaderInfo' | localize">
        <div role="actions">
            <button id="btn_create_JournalVoucher"
                    *ngIf="'Pages.JournalVoucher.Create' | permission"
                    (click)="createJournalVoucher()"
                    class="btn btn-primary blue">
                <i class="fa fa-plus"></i>
                {{ l('CreateNewJournalVoucher') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="filterText"
                                               (ngModelChange)="getJournalVouchers()"
                                               name="filterText"
                                               autoFocus
                                               type="text"
                                               class="form-control"
                                               [placeholder]="l('SearchWithThreeDot')" />
                                        <button class="btn btn-primary" type="submit" (click)="getJournalVouchers()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>
                            <!-- <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="PaymentTermNameFilter">
                                        ({{ l('PaymentTerm') }}) {{ l('Name') }}
                                    </label>
                                    <input type="text"
                                           class="form-control"
                                           id="PaymentTermNameFilter"
                                           name="paymentTermNameFilter"
                                           [(ngModel)]="paymentTermNameFilter" />
                                </div>
                            </div> -->
                            <div class="col-md-12 mt-5">
                                <button (click)="resetFilters()"
                                        class="btn btn-secondary btn-sm"
                                        id="btn-reset-filters">
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span class="clickable-item text-muted"
                                      *ngIf="!advancedFiltersAreShown"
                                      (click)="advancedFiltersAreShown = !advancedFiltersAreShown">
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span class="clickable-item text-muted"
                                      *ngIf="advancedFiltersAreShown"
                                      (click)="advancedFiltersAreShown = !advancedFiltersAreShown">
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable
                                 (onLazyLoad)="getJournalVouchers($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
                                 [paginator]="false"
                                 tableStyleClass="table table-bordered table-hover"
                                 [lazy]="true"
                                 [scrollable]="true"
                                 ScrollWidth="100%"
                                 [tableStyle]="{ 'min-width': '50rem' }"
                                 [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%"
                                        [hidden]="
                                            !isGrantedAny('Pages.JournalVoucher.Edit', 'Pages.JournalVoucher.Delete')
                                        ">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="journalNo">
                                        {{ l('JournalNo') }}
                                        <p-sortIcon field="JournalVoucher.journalNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="journalDate">
                                        {{ l('Date') }}
                                        <p-sortIcon field="JournalVoucher.journalDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 500px" pSortableColumn="description">
                                        {{ l('Description') }}
                                        <p-sortIcon field="JournalVoucher.description"></p-sortIcon>
                                    </th>

                                    <th style="width: 150px" pSortableColumn="debit">
                                        {{ l('Debit') }}
                                        <p-sortIcon field="JournalVoucher.debit"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="credit">
                                        {{ l('Credit') }}
                                        <p-sortIcon field="JournalVoucher.credit"></p-sortIcon>
                                    </th>
                                    
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%"
                                        [hidden]="
                                            !isGrantedAny('Pages.JournalVoucher.Edit', 'Pages.JournalVoucher.Delete')
                                        ">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.JournalVoucher.Create')"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/account/journalVouchers/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.journals.id }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.JournalVoucher.Delete')"
                                                       (click)="deleteJournalVoucher(record.journals)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="print(record.journals.id)">
                                                        {{ l('Print') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('JournalNo') }}</span>
                                        {{ record.journals.journalNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('JournalDate') }}</span>
                                        {{ record.journals.journalDate | date }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Description') }}</span>
                                        {{ record.journals.description }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('Debit') }}</span>
                                        {{ record.journals.debit | priceFormat  }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('Credit') }}</span>
                                        {{ record.journals.credit | priceFormat  }}
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage"
                                         #paginator
                                         (onPageChange)="getJournalVouchers($event)"
                                         [totalRecords]="primengTableHelper.totalRecordsCount"
                                         [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                         [showCurrentPageReport]="true"
                                         [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal (modalSave)="exportToExcel($event)"
                                  #excelColumnSelectionModal></excel-column-selection-modal>
</div>
